import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, Figure, Row } from 'react-bootstrap';
import { roundNumber } from 'utils/common';

const Nexus = ({ t, nexus }) => {
  const data = useMemo(() => nexus, [nexus]);
  return (
    <Row className="observe-simulation-nexus-nexus">
      <Col>
        <Figure>
          <div>
            <strong>{t('_nexus_')}</strong>
          </div>
          <div>
            <div className="observe-simulation-nexus-achievements-board">
              <div className="observe-simulation-nexus-achievements-row">
                <div>{t('_energy_')}</div>
                <div>{roundNumber(data.energy)}</div>
              </div>
              <div className="observe-simulation-nexus-achievements-row">
                <div>{t('_wind_speed_')}</div>
                <div>{data.speed}</div>
              </div>
            </div>
          </div>
        </Figure>
      </Col>
    </Row>
  );
};

Nexus.defaultProps = {
  nexus: {},
};

Nexus.propTypes = {
  t: PropTypes.func.isRequired,
  nexus: PropTypes.shape({}),
};
export default Nexus;
